import { queryOptions } from '@tanstack/react-query';

import { api } from '~/lib/api';
import { i18n } from '~/lib/i18n';

export function jobDetailQueryOptions(orgId: string, deptId: string, jobId: string) {
  return queryOptions({
    queryKey: ['jobs', orgId, deptId, jobId] as const,
    queryFn: async () => {
      const response = await api.api.org[':orgId'].department[':deptId'].jobs[':jobId'].$get({
        param: { orgId, deptId, jobId }
      });
      if (!response.ok) throw new Error(i18n.t('errors.unexpected'));
      return response.json();
    }
  });
}
